__turbopack_context__.v({
  "animate": "shimmer-badge-module__4RJpja__animate",
  "badge": "shimmer-badge-module__4RJpja__badge",
  "blue": "shimmer-badge-module__4RJpja__blue",
  "clickable": "shimmer-badge-module__4RJpja__clickable",
  "green": "shimmer-badge-module__4RJpja__green",
  "label": "shimmer-badge-module__4RJpja__label",
  "pink": "shimmer-badge-module__4RJpja__pink",
  "rightSoft": "shimmer-badge-module__4RJpja__rightSoft",
  "shine": "shimmer-badge-module__4RJpja__shine",
  "sweep": "shimmer-badge-module__4RJpja__sweep",
  "yellow": "shimmer-badge-module__4RJpja__yellow",
});
